// Per-browser memory: recent issues and the scenario draft. The API keeps the
// files; this only remembers what to show. Every access is guarded because
// storage can be missing or throw (private windows, blocked site data).

const HISTORY_KEY = "chaos.history.v1";
const DRAFT_KEY = "chaos.draft.v1";

function safe(storage) {
  try {
    return storage || globalThis.localStorage || null;
  } catch {
    return null;
  }
}

function read(storage, key, fallback) {
  try {
    const raw = safe(storage)?.getItem(key);
    return raw ? JSON.parse(raw) : fallback;
  } catch {
    return fallback;
  }
}

function write(storage, key, value) {
  try {
    safe(storage)?.setItem(key, JSON.stringify(value));
  } catch { /* quota or blocked */ }
}

export function loadHistory(storage) {
  const h = read(storage, HISTORY_KEY, []);
  return Array.isArray(h) ? h : [];
}

export function pushHistory(manifest, storage, max = 20) {
  const entry = { issue_id: manifest.issue_id, name: manifest.name, created_at: manifest.created_at, horizon_hours: manifest.horizon_hours, alert_minutes: manifest.alert_minutes, scenarios: manifest.scenarios?.length ?? 0 };
  const next = [entry, ...loadHistory(storage).filter((e) => e.issue_id !== entry.issue_id)].slice(0, max);
  write(storage, HISTORY_KEY, next);
  return next;
}

export function loadDraft(storage) {
  const d = read(storage, DRAFT_KEY, null);
  return d && Array.isArray(d.scenarios) ? d : null;
}

export function saveDraft(draft, storage) {
  write(storage, DRAFT_KEY, draft);
}
